import { useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mt-6">页面未找到</h2>
        <p className="mt-2 text-base text-secondary-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-secondary-500">您访问的页面可能已被移除或链接失效</p>
        <a href="/" className="mt-6 inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium cursor-pointer hover:bg-primary-600 transition-colors">
          <i className="ri-home-line"></i>
          返回首页
        </a>
      </div>
    </div>
  );
}